import React, { useEffect, useState } from 'react'
// importo la ruta protegida
import { auth } from '../firebase'
// para redirigir al usuario debemos usar el withRouter
import { withRouter } from 'react-router-dom'
// llamo mi componente
import Firestore from './Firestore'



// props --> para sacar mi ruta
const Admin = (props) => {

    // hago un estado para guardar mi usuario
    const [user, setUser] = useState(null)




    // para traer los datos del usuario logeado (currentUser) debemos de traer el useEffect
    useEffect(() => {

        // si en la autenticacion existe el usuario
        if (auth.currentUser) {
            console.log('existe')
            // guardo el usuario su existe en un estado
            // auth.currentUser ----> es toda la informacion del usuario
            setUser(auth.currentUser)
        } else {
            // si el usuario no existe
            console.log('no existe')
            // redirigo al usuario al login
            props.history.push('/login')
        }

        // [] ---> para que se ejecute solo una vez
    }, [props.history])



    return (
        <div className='mt-5'>
            <h3 className='text-center'>Ruta protegida</h3>
            {/* pregunto si el usuario exsite */}
            {
                // pregunto si el usuario tiene algo en el estado
                // pinte esa informacion
                user && (
                    // con user accedemos a la informacion de ----> auth.currentUser
                    // <h3>{user.email}</h3>
                    <Firestore user={user} />
                )
            }
        </div>
    )
}

// withRouter(Admin) ---> para que funcione mi proteccion de rutas y pueda enviarlo a otro lugar
export default withRouter(Admin)